/**
 * Explore API Client - Unified search and explore endpoints
 */

import type { UnifiedSearchFilters, UnifiedSearchResult, ExploreStats, PopularSearches } from '../types';

const API_BASE = '/api/explore';

export const exploreAPI = {
  /**
   * Unified search across all entity types
   */
  async search(filters: UnifiedSearchFilters = {}): Promise<UnifiedSearchResult> {
    const params = new URLSearchParams();

    if (filters.query) params.append('q', filters.query);
    if (filters.entityType) params.append('type', filters.entityType);
    if (filters.field) params.append('field', filters.field);
    if (filters.country) params.append('country', filters.country);
    if (filters.region) params.append('region', filters.region);
    if (filters.minBudget !== undefined) params.append('min_budget', filters.minBudget.toString());
    if (filters.maxBudget !== undefined) params.append('max_budget', filters.maxBudget.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    const response = await fetch(`${API_BASE}/search?${params.toString()}`);
    if (!response.ok) throw new Error('Failed to search');
    return response.json();
  },

  /**
   * Get overall statistics
   */
  async getStats(): Promise<ExploreStats> {
    const response = await fetch(`${API_BASE}/stats`);
    if (!response.ok) throw new Error('Failed to fetch stats');
    return response.json();
  },

  /**
   * Get popular searches data
   */
  async getPopularSearches(): Promise<PopularSearches> {
    const response = await fetch(`${API_BASE}/popular`);
    if (!response.ok) throw new Error('Failed to fetch popular searches');
    return response.json();
  }
};
